import React from 'react';

const InfoBox = ({ title, children }) => {
  return (
    <div className="bg-gray-800 p-4 rounded-lg border-l-4 border-orange-500">
      <h3 className="font-bold text-gray-200 mb-2">{title}</h3>
      <p className="text-gray-300">{children}</p>
    </div>
  );
};

export default InfoBox;